/**
 * Root store actions
 */
export default {};
